const actions = {
    CUSTOMER_LIST_BEGIN: 'CUSTOMER_LIST_BEGIN',
    CUSTOMER_LIST_SUCCESS: 'CUSTOMER_LIST_SUCCESS',
    CUSTOMER_LIST_ERR: 'CUSTOMER_LIST_ERR',
  
    customerListBegin: () => {
      return {
        type: actions.CUSTOMER_LIST_BEGIN,
      };
    },
  
    customerListSuccess: (data) => {
      return {
        type: actions.CUSTOMER_LIST_SUCCESS,
        data,
      };
    },
  
    customerListErr: (err) => {
      return {
        type: actions.CUSTOMER_LIST_ERR,
        err,
      };
    },
  
  };
  
  export default actions;
  